import React, { useState } from 'react';
import './NavbarDashboard.css';
import { Link as Anchor, useLocation } from "react-router-dom";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    faHome,
    faUser,
    faBook,
    faImage,
    faAddressBook,
    faTachometerAlt,
    faCode,
    faCalendarAlt,
    faMapMarkerAlt,
    faBars,
    faTimes,
    faAngleLeft,
    faAngleRight,
    faCog,
    faImages,
    faFileContract,
    faBookOpen
} from '@fortawesome/free-solid-svg-icons';
import logo from '../../../images/logo.png';
import Logout from '../Logout/Logout';
import useSiteConfig from '../../useSiteConfig';
import useAuthUser from '../../useAuthUser';

export default function NavbarDashboard() {
    const { logo: siteLogo } = useSiteConfig();
    const { isAdmin } = useAuthUser();
    const location = useLocation();
    const [mobileOpen, setMobileOpen] = useState(false);
    const [isCollapsed, setIsCollapsed] = useState(false);

    const navItems = [
        { path: '/dashboard', label: 'Inicio', icon: faHome },
        { path: '/dashboard/productos', label: 'Productos', icon: faBook },
        { path: '/dashboard/categorias', label: 'Categorías', icon: faTachometerAlt },
        { path: '/dashboard/galeria', label: 'Galería', icon: faImages },
        { path: '/dashboard/eventos', label: 'Eventos', icon: faCalendarAlt },
        { path: '/dashboard/banners', label: 'Banners', icon: faImage },
        { path: '/dashboard/contacto', label: 'Contacto', icon: faAddressBook },
        { path: '/dashboard/politicas', label: 'Políticas', icon: faFileContract },
        { path: '/dashboard/libro-reclamaciones', label: 'Libro Reclamos', icon: faBookOpen },
        { path: '/dashboard/usuarios', label: 'Usuarios', icon: faUser, adminOnly: true },
        { path: '/dashboard/codigos', label: 'Códigos', icon: faCode },
        { path: '/dashboard/configuracion', label: 'Configuración', icon: faCog, adminOnly: true },
    ];

    const visibleNavItems = navItems.filter(item => !item.adminOnly || isAdmin);

    return (
        <>
            {/* Barra superior visible únicamente en pantallas móviles/tablets */}
            <div className="navbarMobileTopBar">
                <Anchor to="/dashboard" className="mobileBrand">
                    <img src={siteLogo || logo} alt="Agencia de Viajes" onError={(e) => { e.target.src = logo; }} />
                    <span>Admin Agencia</span>
                </Anchor>
                <button
                    className="mobileMenuToggleBtn"
                    onClick={() => setMobileOpen(!mobileOpen)}
                    aria-label="Abrir menú"
                >
                    <FontAwesomeIcon icon={mobileOpen ? faTimes : faBars} />
                </button>
            </div>

            {/* Backdrop desenfocado para móvil */}
            {mobileOpen && (
                <div className="navbarMobileBackdrop" onClick={() => setMobileOpen(false)} />
            )}

            {/* Sidebar moderno */}
            <aside className={`navbarDashboard ${isCollapsed ? 'collapsed' : ''} ${mobileOpen ? 'mobileOpen' : ''}`}>
                <div className="navbarBrandHeader">
                    <Anchor to="/dashboard" className="brandLogoLink">
                        <img src={siteLogo || logo} alt="Agencia de Viajes" className="brandLogoImg" onError={(e) => { e.target.src = logo; }} />
                        {!isCollapsed && (
                            <div className="brandTitles">
                                <span className="brandLogoText">Admin Agencia</span>
                                <span className="brandSubText">Agencia de Viajes</span>
                            </div>
                        )}
                    </Anchor>

                    {/* Botón para alternar colapsado en desktop */}
                    <button
                        className="desktopCollapseToggleBtn"
                        onClick={() => setIsCollapsed(!isCollapsed)}
                        title={isCollapsed ? "Expandir menú" : "Colapsar menú"}
                        type="button"
                    >
                        <FontAwesomeIcon icon={isCollapsed ? faAngleRight : faAngleLeft} />
                    </button>

                    {/* Botón cerrar en móvil */}
                    {mobileOpen && (
                        <button className="mobileCloseBtn" onClick={() => setMobileOpen(false)} type="button">
                            <FontAwesomeIcon icon={faTimes} />
                        </button>
                    )}
                </div>

                <div className="navbarLinks">
                    {visibleNavItems.map((item) => {
                        const isActive = location.pathname === item.path;
                        return (
                            <Anchor
                                key={item.path}
                                to={item.path}
                                onClick={() => setMobileOpen(false)}
                                className={`navLinkItem ${isActive ? 'activeLink' : ''}`}
                                title={isCollapsed ? item.label : ''}
                            >
                                <span className="navLinkIcon">
                                    <FontAwesomeIcon icon={item.icon} />
                                </span>
                                {!isCollapsed && (
                                    <span className="navLinkLabel">{item.label}</span>
                                )}
                            </Anchor>
                        );
                    })}
                </div>

                <div className="navbarDashboardFooter">
                    <Logout isCollapsed={isCollapsed} />
                </div>
            </aside>
        </>
    );
}
